<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>{{title}}</v-card-title>

        <v-card-text>
            <div
                style="text-align: center"
            >
            <v-time-picker
                v-model="time"
                ampm-in-title
            >
            </v-time-picker>
            </div>
        </v-card-text>

        <v-card-actions>

            <v-btn
                text
                @click="onClickUnset"
                v-if="optional"
            >
                {{unset_label}}
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="time == null"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
import { DateTime } from 'luxon';

export default {

    props: {
        title: {
            type: String,
            default: function() { return 'Title'; }
        },

        value: {
            type: [Number, String],
            default: function() { return null; }
        },

        optional: {
            type: Boolean,
            default: function() { return false; }
        },

        unset_label: 
        {
            type: String,
            default: function() { return 'Unset'; }
        },
    },

    data() {
        return {
            dialog: false,
            time: null,
        }
    },

    methods: {

        showDialog(set_time)
        {
            let value = this.value;

            if ( set_time != null ) value = set_time;

            if ( value == null )
            {
                this.time = null;
            }
            else
            {
               this.time = value;
            }

            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
            this.$emit('ok', this.time);
        },

        onCancel()
        {
            this.dialog = false;
        },

        onClickUnset()
        {
            this.dialog = false;
            this.$emit('ok', null);
        }

    },
}
</script>

<style lang="scss" scoped>
</style>